import React, { Fragment, useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { Button, Typography } from "@mui/material";
import { routeName } from "../../../routes/routeName";
import { useTranslation } from "react-i18next";
import FormComponent from "../../../components/gernerateForm/FormComponent";
import formGenerate from "./personal-info/form/dataFormGenerate.data";
import {
  ButtonBack,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import {
  AssignmentInd,
  ContactMail,
  School,
  WorkspacePremium,
  MonetizationOnOutlined,
  FolderOutlined,
  PaymentsOutlined,
  FileDownloadOutlined,
} from "@mui/icons-material";
import StepperCustom from "../../../components/step/Stepper";
import PaymentApplicationFee from "./payment-application-fee/PaymentApplicationFee";
import RegisterInformation from "./register-info/RegisterInformation";
import EducationHistory from "./edication-history/EducationHistory";
import StudentInfo from "./components/text/StudentInfo";
import CertificateList from "./certificate/CertificateList";
import VisaInfo from "./visa-info/VisaInfo";
import TermFeeInfo from "./term-fee/TermFeeInfo";
import { StudentApi } from "../../../api/student/student.api";
import { useLocation, useParams } from "react-router-dom";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { colors_button } from "../../../components/button/util.button";
import ModalChangePassword from "./components/modal/ModalChangePassword";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import UploadFile from "../../../components/upload/UploadFile";
import { AdmissionFrontApi } from "../../../api/admission-front/admission-front.api";

type Props = {};

const ManageStudentDetailPage = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const paramStudentIdParam = id ? parseInt(id) : 0;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id_student_term_payment = queryParams.get("id_student_term_payment");
  const id_student_register_payment = queryParams.get(
    "id_student_register_payment"
  );

  const [inputValueFormStudent, setInputValueFormStudent] = useState({
    section_1: {
      title: "",
      first_name: "",
      last_name: "",
      middle_name: "",
      phone_number: 0,
      email: "",
    },
    section_2: {
      education_level: "",
      name_of_the_institute: "",
      year_of_graduated: 0,
      gpa: 0,
      my_dhamma_qualifications: "",
      english_qualification: "",
      degree: 0,
      faculty: 0,
    },
    section_personal_info: {
      passport_no: "",
      passport_date_issue: "",
      passport_date_expiry: "",
      weight: "",
      height: "",
      blood_type: "",
      date_of_birth: "",
      place_of_birth: "",
      race_ethinc: "",
      nationality: "",
      religion: "",
      occupation: "",
      date_ordination: "",
      sect: "",
      disability: "",
      number_of_sibling: "",
      number_of_sibling_whom_still_study: "",
      skills_interests: "",
    },
    section_address: {
      id_student_address: 0,
      name_of_the_temple: "",
      name_of_the_abbot: "",
      house_no: "",
      street_road: "",
      village: "",
      town_city: "",
      district: "",
      province: "",
      state: "",
      country: "",
      postal_zipcode: "",
    },
    section_parent: {
      id_student_parent: 0,
      father_name: "",
      father_status: "",
      father_occupation: "",
      father_income_per_year: "",
      mother_name: "",
      mother_status: "",
      mother_occupation: "",
      mother_income_per_year: "",
      parent_marriage_status: "",
      referent_person_name: "",
      relationship: "",
      referent_person_occupation: "",
      referent_person_income_per_year: "",
      house_no: "",
      streed_road: "",
      village: "",
      town_city: "",
      district: "",
      province: "",
      state: "",
      country: "",
      postal_zipcode: "",
      phone_number: "",
      email: "",
    },
  });

  const [porpBodyData, setPorpBodyData] = useState<any>({});

  const [documentUpload, setDocumentUpload] = useState([]);
  // const [fileUpload, setFileUpload] = useState([]);
  const [file, setFile] = useState(null);

  const [isShowModalChangePassword, setIsShowModalChangePassword] =
    useState<boolean>(false);

  const [isValidateForm, setIsValidateForm] = useState(false);

  const [tabStep, setTebStep] = useState(0);
  const [isCanEdit, setIsCanEdit] = useState(false);

  const mapStudentDataToState = (data: any) => {
    return {
      section_1: {
        title: data.title || "",
        first_name: data.student_frist_name || "",
        last_name: data.student_last_name || "",
        middle_name: data.student_middle_name || "",
        phone_number: data.phone || 0,
        email: data.email || "",
      },
      section_2: {
        education_level:
          data.infomation.education_type.education_type_name || "",
        name_of_the_institute: data.infomation.name_of_institue || "",
        year_of_graduated: data.infomation.year_graduated || 0,
        gpa: data.infomation.gpa || 0,
        my_dhamma_qualifications: data.infomation.dhamma_qualification || "",
        english_qualification: data.infomation.english_qualification || "",
        degree: data.infomation.id_educational_type || 0,
        faculty: 0, // This value is not present in the response data. Set it to a default value or map it appropriately.
      },
      section_personal_info: {
        passport_no: data.personal.idcard || "",
        passport_date_issue: data.personal.date_of_issue
          ? new Date(data.personal.date_of_issue).toLocaleDateString("en-CA")
          : "",
        passport_date_expiry: data.personal.date_of_expiry
          ? new Date(data.personal.date_of_expiry).toLocaleDateString("en-CA")
          : "",
        weight: data.personal.weight || "",
        height: data.personal.height || "",
        blood_type: data.personal.blood || "",
        date_of_birth: data.personal.date_of_birth
          ? new Date(data.personal.date_of_birth).toLocaleDateString("en-CA")
          : "",
        place_of_birth: data.personal.place_of_birth || "",
        race_ethinc: data.personal.race || "",
        nationality: data.personal.nationality || "",
        religion: data.personal.religion || "",
        occupation: data.personal.occupation || "",
        date_ordination: data.personal.ordination_date
          ? new Date(data.personal.ordination_date).toLocaleDateString("en-CA")
          : "",
        sect: data.personal.sect || "",
        disability: data.personal.dissability || "",
        number_of_sibling: data.personal.number_of_sibling || "",
        number_of_sibling_whom_still_study:
          data.personal.number_of_sibling_still_study || "",
        skills_interests: data.personal.skill || "",
      },
      section_address: {
        id_student_address: data.address.id_student_address || 0,
        name_of_the_temple: data.address.number_of_temple || "",
        name_of_the_abbot: data.address.name_of_abbot || "",
        house_no: data.address.number_of_temple || "",
        street_road: data.address.street || "",
        village: data.address.village || "",
        town_city: data.address.town || "",
        district: data.address.district || "",
        province: data.address.province || "",
        state: data.address.state || "",
        country: data.address.country || "",
        postal_zipcode: data.address.postcode || "",
      },
      section_parent: {
        id_student_parent: data.parent.id_student_parent || 0,
        father_name: data.parent.father_name || "",
        father_status: data.parent.father_status || "",
        father_occupation: data.parent.father_occupation || "",
        father_income_per_year: data.parent.father_income || "",
        mother_name: data.parent.mother_name || "",
        mother_status: data.parent.mother_status || "",
        mother_occupation: data.parent.mother_occupation || "",
        mother_income_per_year: data.parent.mother_income || "",
        parent_marriage_status: data.parent.parent_marriage || "",
        referent_person_name: data.parent.refperson_name || "",
        relationship: data.parent.refperson_relationship || "",
        referent_person_occupation: data.parent.refperson_occupation || "",
        referent_person_income_per_year: data.parent.refperson_income || "",
        house_no: data.parent.refperson_house || "",
        streed_road: data.parent.refperson_street || "",
        village: data.parent.refperson_vilage || "",
        town_city: data.parent.refperson_town || "",
        district: data.parent.refperson_district || "",
        province: data.parent.refperson_province || "",
        state: data.parent.refperson_state || "",
        country: data.parent.refperson_country || "",
        postal_zipcode: data.parent.refperson_postcode || "",
        phone_number: data.parent.refperson_phone || "",
        email: data.parent.refperson_email || "",
      },
    };
  };

  const getStudent = async (
    student_id: number,
    id_student_term_payment: number
  ) => {
    const res = await StudentApi.getStudent(
      student_id
    );
    // const res = await StudentApi.getSingleStudent(
    //   student_id,
    //   "group",
    //   +id_student_term_payment
    // );
    const data = res.data;
    if (data.status < 300) {
      const mappedData = mapStudentDataToState(data.data);
      setInputValueFormStudent(mappedData);
      setDocumentUpload(data.data?.document[0] ?? []);
    }
  };

  useEffect(() => {
    if (paramStudentIdParam && id_student_term_payment) {
      getStudent(paramStudentIdParam, +id_student_term_payment);
    }
  }, [paramStudentIdParam, id_student_term_payment]);

  //  const getDetail = async () => {
  //     dispatch(setLoading());
  
  //     await AdmissionFrontApi.findOne(id).then((res) => {
  //       if (res.status < 300) {
  //         console.log(res.data.data)
  //       }
  //     }).catch((err) => {
  //       console.log(err)
  //     }).finally(() => {
  //       dispatch(unsetLoading());
  //     })
  //   }
  
  //   useEffect(() => {
  //     getDetail()
  //   }, [])
  useEffect(() => {
    setIsCanEdit(false);
  }, [tabStep]);

  // const validateForm = (formData: any, formConfig: any) => {
  //   const errors: any = {};

  //   formConfig.forEach((field: any) => {
  //     if (field.isRequired && formData[field.section][field.name] === "") {
  //       errors[field.name] = `${field.label} is required`;
  //     }
  //   });

  //   return errors;
  // };

  // const handleUploadFileDocument = async (
  //   id_student: number,
  //   newFile: FormData
  // ) => {

  // };

  // const updateStudent = async (
  //   student_id: number,
  //   dataBody: any,
  //   newFile?: File,
  //   id_student_term_payment?: number
  // ) => {
  //   const handleBodyApi = {
  //     infomation: {
  //       title: dataBody.section_1.title,
  //       student_frist_name: dataBody.section_1.first_name,
  //       student_last_name: dataBody.section_1.last_name,
  //       student_middle_name: dataBody.section_1.middle_name,
  //       phone: dataBody.section_1.phone_number.toString(),
  //       email: dataBody.section_1.email,
  //       id_educational_type: dataBody.section_2.degree,
  //       name_of_institue: dataBody.section_2.name_of_the_institute,
  //       year_graduated: dataBody.section_2.year_of_graduated.toString(),
  //       gpa: dataBody.section_2.gpa.toString(),
  //       dhamma_qualification: dataBody.section_2.my_dhamma_qualifications,
  //       english_qualification: dataBody.section_2.english_qualification,
  //     },
  //     personal: {
  //       idcard: dataBody.section_personal_info.passport_no,
  //       date_of_issue:
  //         dataBody.section_personal_info.passport_date_issue !== ""
  //           ? new Date(
  //               dataBody.section_personal_info.passport_date_issue
  //             ).toLocaleDateString("en-CA")
  //           : null,
  //       date_of_expiry:
  //         dataBody.section_personal_info.passport_date_expiry !== ""
  //           ? new Date(
  //               dataBody.section_personal_info.passport_date_expiry
  //             ).toLocaleDateString("en-CA")
  //           : null,
  //       weight: dataBody.section_personal_info.weight,
  //       height: dataBody.section_personal_info.height,
  //       blood: dataBody.section_personal_info.blood_type,
  //       date_of_birth: dataBody.section_personal_info.date_of_birth
  //         ? dataBody.section_personal_info.date_of_birth
  //         : null,
  //       place_of_birth: dataBody.section_personal_info.place_of_birth,
  //       race: dataBody.section_personal_info.race_ethinc,
  //       nationality: dataBody.section_personal_info.nationality,
  //       religion: dataBody.section_personal_info.religion,
  //       occupation: dataBody.section_personal_info.occupation,
  //       ordination_date:
  //         dataBody.section_personal_info.date_ordination !== ""
  //           ? dataBody.section_personal_info.date_ordination
  //           : null,
  //       sect: dataBody.section_personal_info.sect,
  //       dissability: dataBody.section_personal_info.disability,
  //       number_of_sibling: dataBody.section_personal_info.number_of_sibling,
  //       number_of_sibling_still_study:
  //         dataBody.section_personal_info.number_of_sibling_whom_still_study,
  //       skill: dataBody.section_personal_info.skills_interests,
  //     },
  //     address: {
  //       id_student_address: dataBody.section_address.id_student_address,
  //       number_of_temple: dataBody.section_address.name_of_the_temple,
  //       name_of_abbot: dataBody.section_address.name_of_the_abbot,
  //       street: dataBody.section_address.street_road,
  //       village: dataBody.section_address.village,
  //       town: dataBody.section_address.town_city,
  //       province: dataBody.section_address.province,
  //       district: dataBody.section_address.district,
  //       district_sub: "", // Add mapping if available in dataBody
  //       country: dataBody.section_address.country,
  //       postcode: dataBody.section_address.postal_zipcode,
  //     },
  //     parent: {
  //       id_student_parent: dataBody.section_parent.id_student_parent,
  //       father_name: dataBody.section_parent.father_name,
  //       father_status: dataBody.section_parent.father_status,
  //       father_occupation: dataBody.section_parent.father_occupation,
  //       father_income: dataBody.section_parent.father_income_per_year,
  //       mother_name: dataBody.section_parent.mother_name,
  //       mother_status: dataBody.section_parent.mother_status,
  //       mother_occupation: dataBody.section_parent.mother_occupation,
  //       mother_income: dataBody.section_parent.mother_income_per_year,
  //       parent_marriage: dataBody.section_parent.parent_marriage_status,
  //       refperson_name: dataBody.section_parent.referent_person_name,
  //       refperson_relationship: dataBody.section_parent.relationship,
  //       refperson_occupation:
  //         dataBody.section_parent.referent_person_occupation,
  //       refperson_income:
  //         dataBody.section_parent.referent_person_income_per_year,
  //       refperson_house: dataBody.section_parent.house_no,
  //       refperson_street: dataBody.section_parent.streed_road,
  //       refperson_vilage: dataBody.section_parent.village,
  //       refperson_town: dataBody.section_parent.town_city,
  //       refperson_district: dataBody.section_parent.district,
  //       refperson_province: dataBody.section_parent.province,
  //       refperson_district_sub: "", // Add mapping if available in dataBody
  //       refperson_country: dataBody.section_parent.country,
  //       refperson_postcode: dataBody.section_parent.postal_zipcode,
  //       refperson_phone: dataBody.section_parent.phone_number,
  //       refperson_email: dataBody.section_parent.email,
  //     },
  //     modified_id: 0, // This should be set according to your logic
  //   };
  //   await StudentApi.updatedInformation(student_id, handleBodyApi)
  //     .then(async (res) => {
  //       if (res.status < 300) {
  //         if (newFile) {
  //           const formData = new FormData();
  //           formData.append("file", newFile);

  //           await StudentApi.uploadDocument(
  //             student_id,
  //             formData,
  //             newFile.name ?? "-"
  //           )
  //             .then((res) => {
  //               if (res.status < 300) {
  //                 alertSuccess(
  //                   "สำเร็จ",
  //                   "อัพเดทข้อมูลนักศึกษา เรียบร้อยแล้ว",
  //                   "ตกลง"
  //                 );
  //                 if (id_student_term_payment) {
  //                   getStudent(paramStudentIdParam, +id_student_term_payment);
  //                 }
  //                 setIsCanEdit(false);
  //                 setFile(null);
  //               }
  //             })
  //             .catch((error) => alertError("อัพเดทข้อมูลนักศึกษา ไม่สำเร็จ"))
  //             .finally(() => {});
  //         } else {
  //           alertSuccess(
  //             "สำเร็จ",
  //             "อัพเดทข้อมูลนักศึกษา เรียบร้อยแล้ว",
  //             "ตกลง"
  //           );
  //           if (id_student_term_payment) {
  //             getStudent(paramStudentIdParam, +id_student_term_payment);
  //           }
  //           setIsCanEdit(false);
  //         }
  //       }
  //     })
  //     .catch((error) => alertError("อัพเดทข้อมูลนักศึกษา ไม่สำเร็จ"))
  //     .finally(() => {
  //       console.log("success");
  //     });
  // };

  // const updateRegisterInfo = async (
  //   student_id: number,
  //   id_student_register_payment: number,
  //   body: any
  // ) => {
  //   if (id_student_register_payment) {
  //     await StudentApi.fetchUpdateResigterInfo(
  //       student_id,
  //       id_student_register_payment,
  //       body
  //     )
  //       .then((res) => {
  //         if (res.status < 300) {
  //           alertSuccess(
  //             "สำเร็จ",
  //             "อัพเดทข้อมูลการขึ้นทะเบียน เรียบร้อยแล้ว",
  //             "ตกลง"
  //           );
  //           if (id_student_term_payment) {
  //             getStudent(paramStudentIdParam, +id_student_term_payment);
  //           }
  //           setIsCanEdit(false);
  //           setFile(null);
  //         }
  //       })
  //       .catch((error) => alertError("อัพเดทข้อมูลการขึ้นทะเบียน ไม่สำเร็จ"))
  //       .finally(() => {});
  //   } else {
  //     alertSuccess(
  //       "สำเร็จ",
  //       "อัพเดทข้อมูลการขึ้นทะเบียน เรียบร้อยแล้ว",
  //       "ตกลง"
  //     );
  //     if (id_student_term_payment) {
  //       getStudent(paramStudentIdParam, +id_student_term_payment);
  //     }
  //     setIsCanEdit(false);
  //   }
  // };

  // const handleSubmit = (
  //   student_id: number,
  //   dataBody: any,
  //   tabStep: number,
  //   newFile?: File,
  //   id_student_term_payment?: number
  // ) => {
  //   if (isCanEdit && student_id) {
  //     const errors = validateForm(inputValueFormStudent, formGenerate);

  //     if (Object.keys(errors).length > 0) {
  //       setIsValidateForm(true);
  //     } else {
  //       setIsValidateForm(false);
  //       if (tabStep === 0) {
  //         if (id_student_term_payment) {
  //           updateStudent(
  //             student_id,
  //             dataBody,
  //             newFile,
  //             id_student_term_payment
  //           );
  //         }
  //       } else if (tabStep === 2) {
  //         if (id_student_register_payment) {
  //           updateRegisterInfo(
  //             +student_id,
  //             +id_student_register_payment,
  //             porpBodyData
  //           );
  //         }
  //       } else {
  //         alert("not save");
  //       }
  //     }
  //   }
  // };

  const allStep = [
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_PERSONAL_INFO"),
      isAccept: false,
      icon: <AssignmentInd />,
    },
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_PAYMENT_APPLICATION_FEE"),
      isAccept: false,
      icon: <MonetizationOnOutlined />,
    },
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_REGISTRATION_INFO"),
      isAccept: false,
      icon: <FolderOutlined />,
    },
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_EDUCATION_HISTORY"),
      isAccept: false,
      icon: <School />,
    },
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_EDUCATION_CERTIFICATE"),
      isAccept: false,
      icon: <WorkspacePremium />,
    },
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_VISA_INFO"),
      isAccept: false,
      icon: <ContactMail />,
    },
    {
      name: t("STUDENT_MANAGEMENT.COMMON.TAB_TERM_FEES"),
      isAccept: false,
      icon: <PaymentsOutlined />,
    },
  ];

  const handleDownloadFile = async (
    student_id: number,
    id_student_file: number,
    id_student_term_payment: number
  ) => {
    await StudentApi.downloadFileDocument(student_id, id_student_file)
      .then((res) => {
        if (res.status < 300) {
          alertSuccess(t("สำเร็จ"), t("ดาวน์โหลดไฟล์เรียบร้อย"), t("ตกลง"));
          getStudent(paramStudentIdParam, id_student_term_payment);
          setIsCanEdit(false);
          setFile(null);
        }
      })
      .catch((error) => alertError(t("ดาวน์โหลด ไม่สำเร็จ")))
      .finally(() => {});
  };

  const handleDeleteFile = async (
    student_id: number,
    id_student_file: number,
    id_student_term_payment: number
  ) => {
    await StudentApi.deleteFileDocument(student_id, id_student_file)
      .then((res) => {
        if (res.status < 300) {
          alertSuccess(t("สำเร็จ"), t("ลบไฟล์เรียบร้อย"), t("ตกลง"));
          getStudent(paramStudentIdParam, id_student_term_payment);
          setIsCanEdit(false);
          setFile(null);
        }
      })
      .catch((error) => alertError(t("ลบไฟล์ ไม่สำเร็จ")))
      .finally(() => {});
  };

  const componentRender = [
    {
      step: 0,
      component: (
        <>
          <section className="w-full gap-4">
            <FormComponent
              formGenerate={formGenerate}
              inputValue={inputValueFormStudent}
              setInputValue={setInputValueFormStudent}
              handleCheckValid={isValidateForm}
              isCanEdit={isCanEdit}
              permission={"admin"}
            />
          </section>

          <section className="w-full my-2 gap-4">
            <Typography variant="h5" gutterBottom>
              {t("STUDENT_MANAGEMENT.FORM.DOCUMENT_HEADER")}
            </Typography>

            <Button
              startIcon={<FileDownloadOutlined />}
              variant="contained"
              color="success"
              sx={{ marginBottom: 2 }}
            >
              {t("BUTTON.DOWNLOAD_ALL")}
            </Button>

            <UploadFile
              onDrop={(file) => {
                setFile(file);
              }}
              file={file}
              onDeleteFile={() => {
                setFile(null);
              }}
              noClick={!isCanEdit}
            />

            {documentUpload && documentUpload.length > 0
              ? documentUpload.map((item: any, index) => {
                  return (
                    <div
                      key={index + 1}
                      style={{
                        marginTop: 8,
                      }}
                    >
                      <UploadFile
                        fileAttachmentId={item.id_student_file}
                        fileAttachmentName={"-"}
                        noClick={item.id_student_file ?? true}
                        onDeleteFile={() => {}}
                        // helperText={item?.id_student_file}
                        onDrop={() => {}}
                        // file={item?.file_path}
                        formatText={t("FILE_UPLOAD.FILE_SIZE")}
                        disableDeleteFileId={!isCanEdit}
                        onDeleteFileId={() => {
                          if (id_student_term_payment) {
                            handleDeleteFile(
                              item.id_student,
                              item.id_student_file,
                              +id_student_term_payment
                            );
                          }
                        }}
                        hiddenDownloadFile={isCanEdit}
                        {...(!isCanEdit
                          ? {
                              onDownloadFile: () => {
                                if (id_student_term_payment) {
                                  handleDownloadFile(
                                    item.id_student,
                                    item.id_student_file,
                                    +id_student_term_payment
                                  );
                                }
                              },
                            }
                          : {})}
                      />
                    </div>
                  );
                })
              : null}
          </section>
        </>
      ),
    },
    {
      step: 1,
      component: (
        <PaymentApplicationFee
          student_id={paramStudentIdParam}
          id_student_register_payment={
            id_student_register_payment ? +id_student_register_payment : 0
          }
          data={inputValueFormStudent}
        />
      ),
    },
    {
      step: 2,
      component: (
        <RegisterInformation
          student_id={paramStudentIdParam}
          id_student_register_payment={
            id_student_register_payment ? +id_student_register_payment : 0
          }
          isCanEdit={isCanEdit}
          setPorpBodyData={setPorpBodyData}
        />
      ),
    },
    {
      step: 3,
      component: (
        <EducationHistory
          student_id={paramStudentIdParam}
          student_data={inputValueFormStudent}
          id_student_register_payment={
            id_student_register_payment ? +id_student_register_payment : 0
          }
          id_student_term_payment={
            id_student_term_payment ? +id_student_term_payment : 0
          }
        />
      ),
    },
    {
      step: 4,
      component: <CertificateList student_id={paramStudentIdParam} />,
    },
    {
      step: 5,
      component: (
        <VisaInfo
          student_id={paramStudentIdParam}
          student_data={inputValueFormStudent}
        />
      ),
    },
    {
      step: 6,
      component: <TermFeeInfo student_id={paramStudentIdParam} />,
    },
  ];

  // const handleDeleteAccount = async () => {
  //   if (id) {
  //     alertActive(
  //       "ลบนักศึกษา",
  //       "ท่านต้องการลบนักศึกษา ใช่หรือไม่",
  //       undefined,
  //       undefined,
  //       async () => {
  //         dispatch(setLoading());
  //         await StudentApi.deleteStudent(+id)
  //           .then((res) => {
  //             if (res.status < 300) {
  //               alertSuccess(
  //                 "ลบนักศึกษาเรียบร้อย",
  //                 undefined,
  //                 undefined,
  //                 () => {
  //                   navigate(routeName.cms.ManageStudents);
  //                 }
  //               );
  //             }
  //           })
  //           .catch(() => {
  //             alertError("ลบนักศึกษา ไม่สำเร็จ");
  //           })
  //           .finally(() => {
  //             dispatch(unsetLoading());
  //           });
  //       }
  //     );
  //   }
  //   return;
  // };

  return (
    <>
      <ModalChangePassword
        setIsOpenModal={(isOpen: boolean) =>
          setIsShowModalChangePassword(isOpen)
        }
        isOpenModal={isShowModalChangePassword}
      />
      <div className="h-auto">
        {/* breadcrumbs */}
        <NavigateListCustom
          navigateData={[
            {
              name: t("STUDENT_MANAGEMENT.TOPIC.MANAGE_STUDENT_LIST"),
              key: "1",
              pathName: routeName.cms.ManageStudents,
            },
            {
              name: t("STUDENT_MANAGEMENT.TOPIC.STUDENT_INFORMATION"),
              key: "2",
              pathName:
                routeName.cms.ManageStudents + `/detail/${paramStudentIdParam}`,
            },
          ]}
        />

        {/* header */}
        <section className="my-4">
          <Typography variant="h3">
            {t("STUDENT_MANAGEMENT.TITLE.STUDENT_PERSONAL_INFO")}
          </Typography>
        </section>

        <section className="my-2">
          <StudentInfo
            fulllname={
              inputValueFormStudent.section_1.title +
              " " +
              inputValueFormStudent.section_1.first_name +
              " " +
              inputValueFormStudent.section_1.last_name
            }
            nickname={inputValueFormStudent.section_1.middle_name}
            course={"-"}
          />
        </section>

        {/* step */}
        <section className="w-full">
          <StepperCustom
            step={tabStep}
            setStep={(num: number) => {
              setTebStep(num);
            }}
            stepLabel={allStep}
            view={true}
          />
        </section>

        {/* main content */}
        <section className="my-4">
          {componentRender
            .filter((item) => item.step === tabStep)
            .map((item, index) => (
              <div key={index + 1}>{item.component}</div>
            ))}

          {/* button action */}
          <section className="w-full my-8 flex flex-wrap justify-center items-center gap-4">
            <ButtonBack
              onClick={() => {
                // isCanEdit
                //   ? setIsCanEdit(!isCanEdit)
                //   : navigate(routeName.cms.ManageStudents);
                  navigate(routeName.cms.ManageStudents);
              }}
              buttonName={t("STUDENT_MANAGEMENT.COMMON.BUTTON_BACK")}
              btnProps={{
                width: "150px",
              }}
            />

            {/* {tabStep === 0 || tabStep === 2 ? (
              <>
                {isCanEdit ? (
                  <ButtonPrimary
                    onClick={() => {
                      if (id_student_term_payment) {
                        handleSubmit(
                          paramStudentIdParam,
                          inputValueFormStudent,
                          tabStep,
                          file ? file[0] : undefined,
                          +id_student_term_payment
                        );
                      }
                    }}
                    buttonName={t("STUDENT_MANAGEMENT.COMMON.BUTTON_SAVE")}
                    btnProps={{
                      bg: "#4198E9",
                      width: "150px",
                    }}
                  />
                ) : (
                  <ButtonPrimary
                    onClick={() => {
                      setIsCanEdit(true);
                    }}
                    buttonName={t("STUDENT_MANAGEMENT.COMMON.BUTTON_UPDATE")}
                    btnProps={{
                      width: "150px",
                    }}
                  />
                )}
              </>
            ) : null}

            {!isCanEdit ? (
              <>
                <ButtonPrimary
                  buttonName={t(
                    "STUDENT_MANAGEMENT.COMMON.BUTTON_CHANGE_PASSWORD"
                  )}
                  btnProps={{
                    bg: colors_button.sub_primary,
                    width: "200px",
                  }}
                  onClick={() => setIsShowModalChangePassword(true)}
                  mode={"password"}
                />

                <ButtonPrimary
                  mode="del"
                  onClick={() => handleDeleteAccount()}
                  buttonName={t(
                    "STUDENT_MANAGEMENT.COMMON.BUTTON_DELETE_ACCOUNT"
                  )}
                  btnProps={{
                    width: "150px",
                  }}
                />
              </>
            ) : null} */}
          </section>
        </section>
      </div>
    </>
  );
};

export default ManageStudentDetailPage;
